import FaqModal from "./FaqModal";

export default FaqModal;
